<template>
  <div class="home">
    <app-header></app-header>
    <app-contact-us></app-contact-us>
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/general/Header.vue";
import ContactUs from "@/components/contactus/contactus.vue";
import Footer from "@/components/general/Footer.vue";


export default {
name: "home",
components: {
  'app-header': Header,
  'app-contact-us': ContactUs,
  'app-footer' : Footer,
  }
}   

</script>
